import editNode from './edit-node';

const editMap = editNode;

export default editMap;